import React from 'react';
import { useTranslation } from '../i18n';

const BookProgress = ({ book }) => {
  const { t } = useTranslation();
  return (
    book.number_of_pages > 0 && (
      <div className="progress-wrapper">
        <div className="progress-label">
          <div className="pt-65 nowrap">{t.bookprogress}</div>
          <div className="pt-65 nowrap">
            {(
              Math.round(
                10 *
                  100 *
                  ((book.pages ? book.pages : 0) / book.number_of_pages),
              ) / 10
            ).toLocaleString()}
            {' %'}
          </div>
        </div>
        <progress
          className="progress-bar"
          max="100"
          value={100 * ((book.pages ? book.pages : 0) / book.number_of_pages)}
        />
      </div>
    )
  );
};

export default BookProgress;
